import { render, staticRenderFns } from "./ECommerceCollect.vue?vue&type=template&id=d0489e94&scoped=true&"
import script from "./ECommerceCollect.vue?vue&type=script&lang=js&"
export * from "./ECommerceCollect.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceCollect.vue?vue&type=style&index=0&id=d0489e94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0489e94",
  null
  
)

export default component.exports